/* eslint-disable react/no-multi-comp, react/no-unused-prop-types */
import classNames from 'classnames';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';
import intlShape from '../../lib/intlShape.js';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import bowser from 'bowser';
import React from 'react';
import md5 from 'js-md5';

import VM from '@scratch/scratch-vm';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import CommunityButton from './community-button.jsx';
import ShareButton from './share-button.jsx';
import {ComingSoonTooltip} from '../coming-soon/coming-soon.jsx';
import Divider from '../divider/divider.jsx';
import SaveStatus from './save-status.jsx';
import ProjectWatcher from '../../containers/project-watcher.jsx';
import MenuBarMenu from './menu-bar-menu.jsx';
import {MenuItem, MenuSection, Submenu} from '../menu/menu.jsx';
import ProjectTitleInput from './project-title-input.jsx';
import AuthorInfo from './author-info.jsx';
import AccountNav from '../../components/menu-bar/account-nav.jsx';
import LoginDropdown from './login-dropdown.jsx';
import SB3Downloader from '../../containers/sb3-downloader.jsx';
import DeletionRestorer from '../../containers/deletion-restorer.jsx';
import TurboMode from '../../containers/turbo-mode.jsx';
import MenuBarHOC from '../../containers/menu-bar-hoc.jsx';
import SettingsMenu from './settings-menu.jsx';

import {openTipsLibrary, openDebugModal} from '../../reducers/modals';
import {setPlayer} from '../../reducers/mode';
import {
    isTimeTravel220022BC,
    isTimeTravel1920,
    isTimeTravel1990,
    isTimeTravel2020,
    isTimeTravelNow,
    setTimeTravel
} from '../../reducers/time-travel';
import {
    autoUpdateProject,
    createProject,
    getIsUpdating,
    getIsShowingProject,
    manualUpdateProject,
    requestNewProject,
    remixProject,
    saveProjectAsCopy
} from '../../reducers/project-state';
import {
    openAboutMenu,
    closeAboutMenu,
    aboutMenuOpen,
    openAccountMenu,
    closeAccountMenu,
    accountMenuOpen,
    openFileMenu,
    closeFileMenu,
    fileMenuOpen,
    openEditMenu,
    closeEditMenu,
    editMenuOpen,
    openLoginMenu,
    closeLoginMenu,
    loginMenuOpen,
    openModeMenu,
    closeModeMenu,
    modeMenuOpen,
    settingsMenuOpen,
    openSettingsMenu,
    closeSettingsMenu
} from '../../reducers/menus';

import collectMetadata from '../../lib/collect-metadata';
import {PLATFORM} from '../../lib/platform';

import styles from './menu-bar.css';

import helpIcon from '../../lib/assets/icon--tutorials.svg';
import mystuffIcon from './icon--mystuff.png';
import profileIcon from './icon--profile.png';
import remixIcon from './icon--remix.svg';
import dropdownCaret from './dropdown-caret.svg';
import aboutIcon from './icon--about.svg';
import fileIcon from './icon--file.svg';
import editIcon from './icon--edit.svg';
import debugIcon from '../debug-modal/icons/icon--debug.svg';

import ikoosLogo from './ikoos-logo.svg';
import ikoosLogoAndroid from './ikoos-logo-android.svg';
import ninetiesLogo from './nineties_logo.svg';
import catLogo from './cat_logo.svg';
import prehistoricLogo from './prehistoric-logo.svg';
import oldtimeyLogo from './oldtimey-logo.svg';

import sharedMessages from '../../lib/shared-messages';

import {AccountMenuOptionsPropTypes} from '../../lib/account-menu-options';

import Cards from '../cards/cards.jsx';


const ariaMessages = defineMessages({
    tutorials: {
        id: 'gui.menuBar.tutorialsLibrary',
        defaultMessage: 'Tutorials',
        description: 'accessibility text for the tutorials button'
    },
    debug: {
        id: 'gui.menuBar.debug',
        defaultMessage: 'Debug',
        description: 'accessibility text for the debug button'
    }
});

const getIkoosLogo = platform => (platform === PLATFORM.ANDROID ? ikoosLogoAndroid : ikoosLogo);

const IKOOS_TEMPLATE_API_URL = 'https://api.ikoos.net/public/index.php/api/get_template';

const parseTemplateData = data => {
    const templatePayload = data && Object.prototype.hasOwnProperty.call(data, 'template') ? data.template : data;
    const templateData = typeof templatePayload === 'string' ? JSON.parse(templatePayload) : templatePayload;

    if (!Array.isArray(templateData)) {
        throw new Error('Template API: response is not an array');
    }

    return templateData;
};

const getTemplateInstruction = tpl => {
    if (tpl && tpl.instruction && typeof tpl.instruction === 'object') {
        return tpl.instruction;
    }
    return {};
};

const getTemplateHtmlUrl = tpl => {
    const instruction = getTemplateInstruction(tpl);
    return tpl.guideUrl ||
        tpl.htmlUrl ||
        tpl.contentUrl ||
        tpl.instructionUrl ||
        instruction.url ||
        instruction.guideUrl ||
        instruction.htmlUrl ||
        null;
};

const getTemplatePreviewUrl = tpl => tpl.previewUrl || tpl.preview || tpl.img || null;

const getTemplateProjectUrl = tpl => tpl.sb3Url || tpl.projectUrl || tpl.sb3 || null;

const getTemplateTitle = tpl => {
    const instruction = getTemplateInstruction(tpl);
    return instruction.title ||
        tpl.instructionTitle ||
        tpl.deckName ||
        `${tpl.groupName || 'Template'} - ${tpl.label || 'Petunjuk'}`;
};

const emptyTemplateDeckAction = () => {};

class TemplateLoadMenuItem extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClick'
        ]);
    }
    handleClick () {
        this.props.onSelect({
            ...this.props.item,
            groupName: this.props.groupName,
            groupKey: this.props.groupName
        });
    }
    render () {
        const {isRtl, item} = this.props;
        return (
            <MenuItem
                isRtl={isRtl}
                onClick={this.handleClick}
            >
                {item.label}
            </MenuItem>
        );
    }
}

TemplateLoadMenuItem.propTypes = {
    groupName: PropTypes.string.isRequired,
    isRtl: PropTypes.bool,
    item: PropTypes.shape({
        label: PropTypes.string.isRequired
    }).isRequired,
    onSelect: PropTypes.func.isRequired
};

const MenuBarItemTooltip = ({
    children,
    className,
    enable,
    id,
    place = 'bottom'
}) => {
    if (enable) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
    return (
        <ComingSoonTooltip
            className={classNames(styles.comingSoon, className)}
            place={place}
            tooltipClassName={styles.comingSoonTooltip}
            tooltipId={id}
        >
            {children}
        </ComingSoonTooltip>
    );
};


MenuBarItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.string,
    place: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};

const MenuItemTooltip = ({id, isRtl, children, className}) => (
    <ComingSoonTooltip
        className={classNames(styles.comingSoon, className)}
        isRtl={isRtl}
        place={isRtl ? 'left' : 'right'}
        tooltipClassName={styles.comingSoonTooltip}
        tooltipId={id}
    >
        {children}
    </ComingSoonTooltip>
);

MenuItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    isRtl: PropTypes.bool
};

const AboutButton = props => (
    <Button
        className={classNames(styles.menuBarItem, styles.hoverable)}
        iconClassName={styles.aboutIcon}
        iconSrc={aboutIcon}
        onClick={props.onClick}
    />
);

AboutButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

class MenuBar extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            templateMenuOpen: false,
            templateModalOpen: false,
            templateModalTitle: '',
            templateModalHtml: '',
            templateCardsOpen: false,
            templateCardsDeckId: null,
            templateCardsContent: {},
            templateCardsStep: 0,
            templateCardsExpanded: true,
            templateCardsDragging: false,
            templateCardsX: 0,
            templateCardsY: 0,
            templateData: [],
            templateDataLoading: false,
            templateDataError: null
        };
        
        // Template menu aktif kalau URL mengandung ?c=... dan code-nya valid via API
        // contoh: /editor?c=experience-days
        this.isExperienceDays = false;
        this.templateCodeKey = null;
        try {
            const params = new URLSearchParams(window.location.search);
            this.templateCodeKey = params.get('c');
        } catch (e) {
            this.isExperienceDays = false;
            this.templateCodeKey = null;
        }
        
        bindAll(this, [
            'handleClickNew',
            'handleClickRemix',
            'handleClickSave',
            'handleClickSaveAsCopy',
            'handleClickSeeCommunity',
            'handleClickShare',
            'handleSetMode',
            'handleKeyPress',
            'handleRestoreOption',
            'getSaveToComputerHandler',
            'restoreOptionMessage',
            'handleClickTemplate',
            'handleRequestCloseTemplate',
            'handleOpenTemplateCards',
            'handleCloseTemplateCards',
            'handleToggleTemplateCardsExpand',
            'handleTemplateCardsDrag',
            'handleTemplateCardsStartDrag',
            'handleTemplateCardsEndDrag',
            'handleTemplateCardsNextStep',
            'handleTemplateCardsPrevStep',
            'handleActivateTemplateDeckFactory',
            'fetchTemplateData',
            'handleLoadTemplateFromApi'
        ]);
    }
    componentDidMount () {
        document.addEventListener('keydown', this.handleKeyPress);

        // Validasi code template dari parameter ?c=... via API IKOOS
        if (this.templateCodeKey) {
            const codeKey = this.templateCodeKey;
            const hashTimestamp = md5(`${codeKey}IKOOSPRO`);

            this.setState({templateDataLoading: true, templateDataError: null});

            fetch(IKOOS_TEMPLATE_API_URL, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: new URLSearchParams({
                    code_key: codeKey,
                    timestamp: hashTimestamp
                }).toString()
            })
                .then(res => {
                    if (!res.ok) throw new Error(`IKOOS template API error: ${res.status}`);
                    return res.json();
                })
                .then(data => {
                    if (data && data.success === true) {
                        const templateData = parseTemplateData(data);
                        this.isExperienceDays = true;
                        this.setState({templateData, templateDataLoading: false});
                    } else {
                        throw new Error('IKOOS template API response was not successful');
                    }
                })
                .catch(err => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                    this.setState({templateDataError: err.message, templateDataLoading: false});
                });
        }
    }
    componentWillUnmount () {
        document.removeEventListener('keydown', this.handleKeyPress);
    }
    handleClickNew () {
        // if the project is dirty, and user owns the project, we will autosave.
        // but if they are not logged in and can't save, user should consider
        // downloading or logging in first.
        // Note that if user is logged in and editing someone else's project,
        // they'll lose their work.
        const readyToReplaceProject = this.props.confirmReadyToReplaceProject(
            this.props.intl.formatMessage(sharedMessages.replaceProjectWarning)
        );
        this.props.onRequestCloseFile();
        if (readyToReplaceProject) {
            this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
        }
        this.props.onRequestCloseFile();
    }
    
    // UPDATE RISCO =======================
    fetchTemplateData () {
        this.setState({templateDataLoading: true, templateDataError: null});
        
        fetch('https://class.ikoos.net/static/template.json', {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        })
            .then(res => {
                if (!res.ok) throw new Error(`Template API error: ${res.status}`);
                return res.json();
            })
            .then(data => {
            // data diharapkan: [{group, items:[{label,sb3,preview,deckId}, ...]}, ...]
                this.setState({templateData: parseTemplateData(data), templateDataLoading: false});
            })
            .catch(err => {
            // eslint-disable-next-line no-console
                console.error(err);
                this.setState({templateDataError: err.message, templateDataLoading: false});
            });
    }

    handleLoadTemplateFromApi (tpl) {
        // tpl: {label, sb3, preview, deckId} + kita tambah groupName dari caller
        this.handleRequestCloseTemplate();
        
        // gate: hanya aktif di experience-days
        if (!this.isExperienceDays) return;
        
        const projectUrl = getTemplateProjectUrl(tpl);
        const previewUrl = getTemplatePreviewUrl(tpl);
        const guideUrl = getTemplateHtmlUrl(tpl);
        const title = getTemplateTitle(tpl);

        if (projectUrl) {
            fetch(projectUrl)
                .then(res => {
                    if (!res.ok) throw new Error(`Failed to fetch ${projectUrl}: ${res.status}`);
                    return res.arrayBuffer();
                })
                .then(buffer => this.props.vm.loadProject(buffer))
                .catch(err => {
                // eslint-disable-next-line no-console
                    console.error(err);
                });
        }
        
        // buka Cards petunjuk. Jika guideUrl belum ada, tetap fallback ke preview lama.
        const deckId = tpl.deckId || `${tpl.groupKey || 'deck'}-${tpl.label}`.toLowerCase().replace(/\s+/g, '-');
        
        const content = {
            [deckId]: {
                name: title,
                img: previewUrl || '',
                steps: [
                    {
                        headerTitle: title,
                        title: null,
                        htmlUrl: guideUrl,
                        image: previewUrl || ''
                    }
                ]
            }
        };
        
        this.handleOpenTemplateCards({deckId, content});
    }

    handleClickTemplate () {
        this.setState(prev => ({templateMenuOpen: !prev.templateMenuOpen}));
    }
    
    handleRequestCloseTemplate () {
        this.setState({templateMenuOpen: false});
    }

    handleOpenTemplateCards ({deckId, content}) {
        this.setState({
            templateCardsOpen: true,
            templateCardsDeckId: deckId,
            templateCardsContent: content,
            templateCardsStep: 0,
            templateCardsExpanded: true
        });
    }
    
    handleCloseTemplateCards () {
        this.setState({
            templateCardsOpen: false,
            templateCardsDeckId: null,
            templateCardsContent: {},
            templateCardsStep: 0
        });
    }
    
    handleToggleTemplateCardsExpand () {
        this.setState(prev => ({templateCardsExpanded: !prev.templateCardsExpanded}));
    }
    
    handleTemplateCardsDrag (e, data) {
        this.setState({templateCardsX: data.x, templateCardsY: data.y});
    }
    handleTemplateCardsStartDrag () {
        this.setState({templateCardsDragging: true});
    }
    handleTemplateCardsEndDrag () {
        this.setState({templateCardsDragging: false});
    }
    handleTemplateCardsNextStep () {}
    handleTemplateCardsPrevStep () {}
    handleActivateTemplateDeckFactory () {
        return emptyTemplateDeckAction;
    }
    // END  UPDATE RISCO
    
    handleClickRemix () {
        this.props.onClickRemix();
        this.props.onRequestCloseFile();
    }
    handleClickSave () {
        if (this.props.canSave) {
            this.props.onClickSave();
        } else if (this.props.canCreateNew) {
            this.props.onClickCreateProject();
        }
        this.props.onRequestCloseFile();
    }
    handleClickSaveAsCopy () {
        this.props.onClickSaveAsCopy();
        this.props.onRequestCloseFile();
    }
    handleClickSeeCommunity (waitForUpdate) {
        if (this.props.shouldSaveBeforeTransition()) {
            this.props.autoUpdateProject(); // save before transitioning to project page
            waitForUpdate(true); // queue the transition to project page
        } else {
            waitForUpdate(false); // immediately transition to project page
        }
    }
    handleClickShare (waitForUpdate) {
        if (!this.props.isShared) {
            if (this.props.canShare) { // save before transitioning to project page
                this.props.onShare();
            }
            if (this.props.canSave) { // save before transitioning to project page
                this.props.autoUpdateProject();
                waitForUpdate(true); // queue the transition to project page
            } else {
                waitForUpdate(false); // immediately transition to project page
            }
        }
    }
    handleSetMode (mode) {
        return () => {
            // Turn on/off filters for modes.
            if (mode === '1920') {
                document.documentElement.style.filter = 'brightness(.9)contrast(.8)sepia(1.0)';
                document.documentElement.style.height = '100%';
            } else if (mode === '1990') {
                document.documentElement.style.filter = 'hue-rotate(40deg)';
                document.documentElement.style.height = '100%';
            } else {
                document.documentElement.style.filter = '';
                document.documentElement.style.height = '';
            }

            // Change logo for modes
            if (mode === '1990') {
                document.getElementById('logo_img').src = ninetiesLogo;
            } else if (mode === '2020') {
                document.getElementById('logo_img').src = catLogo;
            } else if (mode === '1920') {
                document.getElementById('logo_img').src = oldtimeyLogo;
            } else if (mode === '220022BC') {
                document.getElementById('logo_img').src = prehistoricLogo;
            } else {
                document.getElementById('logo_img').src = getIkoosLogo(this.props.platform);
            }

            this.props.onSetTimeTravelMode(mode);
        };
    }
    handleRestoreOption (restoreFun) {
        return () => {
            restoreFun();
            this.props.onRequestCloseEdit();
        };
    }
    handleKeyPress (event) {
        const modifier = bowser.mac ? event.metaKey : event.ctrlKey;
        if (modifier && event.key === 's') {
            this.handleClickSave();
            event.preventDefault();
        }
    }
    getSaveToComputerHandler (downloadProjectCallback) {
        return () => {
            this.props.onRequestCloseFile();
            downloadProjectCallback();
            if (this.props.onProjectTelemetryEvent) {
                const metadata = collectMetadata(this.props.vm, this.props.projectTitle, this.props.locale);
                this.props.onProjectTelemetryEvent('projectDidSave', metadata);
            }
        };
    }
    restoreOptionMessage (deletedItem) {
        switch (deletedItem) {
        case 'Sprite':
            return (<FormattedMessage
                defaultMessage="Restore Sprite"
                description="Menu bar item for restoring the last deleted sprite."
                id="gui.menuBar.restoreSprite"
            />);
        case 'Sound':
            return (<FormattedMessage
                defaultMessage="Restore Sound"
                description="Menu bar item for restoring the last deleted sound."
                id="gui.menuBar.restoreSound"
            />);
        case 'Costume':
            return (<FormattedMessage
                defaultMessage="Restore Costume"
                description="Menu bar item for restoring the last deleted costume."
                id="gui.menuBar.restoreCostume"
            />);
        default: {
            return (<FormattedMessage
                defaultMessage="Restore"
                description="Menu bar item for restoring the last deleted item in its disabled state." /* eslint-disable-line max-len */
                id="gui.menuBar.restore"
            />);
        }
        }
    }
    buildAboutMenu (onClickAbout) {
        if (!onClickAbout) {
            // hide the button
            return null;
        }
        if (typeof onClickAbout === 'function') {
            // make a button which calls a function
            return <AboutButton onClick={onClickAbout} />;
        }
        // assume it's an array of objects
        // each item must have a 'title' FormattedMessage and a 'handleClick' function
        // generate a menu with items for each object in the array
        return (
            <div
                className={classNames(styles.menuBarItem, styles.hoverable, {
                    [styles.active]: this.props.aboutMenuOpen
                })}
                onClick={this.props.onRequestOpenAbout}
            >
                <img
                    className={styles.aboutIcon}
                    src={aboutIcon}
                />
                <MenuBarMenu
                    className={classNames(styles.menuBarMenu)}
                    open={this.props.aboutMenuOpen}
                    place={this.props.isRtl ? 'right' : 'left'}
                    onRequestClose={this.props.onRequestCloseAbout}
                >
                    {
                        onClickAbout.map(itemProps => (
                            <MenuItem
                                key={itemProps.title}
                                isRtl={this.props.isRtl}
                                onClick={this.wrapAboutMenuCallback(itemProps.onClick)}
                            >
                                {itemProps.title}
                            </MenuItem>
                        ))
                    }
                </MenuBarMenu>
            </div>
        );
    }
    wrapAboutMenuCallback (callback) {
        return () => {
            callback();
            this.props.onRequestCloseAbout();
        };
    }
    render () {
        const saveNowMessage = (
            <FormattedMessage
                defaultMessage="Save now"
                description="Menu bar item for saving now"
                id="gui.menuBar.saveNow"
            />
        );
        const createCopyMessage = (
            <FormattedMessage
                defaultMessage="Save as a copy"
                description="Menu bar item for saving as a copy"
                id="gui.menuBar.saveAsCopy"
            />
        );
        const remixMessage = (
            <FormattedMessage
                defaultMessage="Remix"
                description="Menu bar item for remixing"
                id="gui.menuBar.remix"
            />
        );
        const newProjectMessage = (
            <FormattedMessage
                defaultMessage="New"
                description="Menu bar item for creating a new project"
                id="gui.menuBar.new"
            />
        );
        const remixButton = (
            <Button
                className={classNames(
                    styles.menuBarButton,
                    styles.remixButton
                )}
                iconClassName={styles.remixButtonIcon}
                iconSrc={remixIcon}
                onClick={this.handleClickRemix}
            >
                {remixMessage}
            </Button>
        );
        // Show the About button only if we have a handler for it (like in the desktop app)
        const aboutButton = this.buildAboutMenu(this.props.onClickAbout);

        const menuOpts = this.props.accountMenuOptions;

        return (
            <Box
                className={classNames(
                    this.props.className,
                    styles.menuBar
                )}
                aria-label={this.props.ariaLabel}
                role={this.props.ariaRole}
                element="header"
            >
                <div className={styles.mainMenu}>
                    <div className={styles.fileGroup}>
                        <div className={classNames(styles.menuBarItem)}>
                            <img
                                id="logo_img"
                                alt="IKOOS"
                                className={classNames(styles.ikoosLogo, {
                                    [styles.clickable]: typeof this.props.onClickLogo !== 'undefined'
                                })}
                                draggable={false}
                                src={getIkoosLogo(this.props.platform)}
                                onClick={this.props.onClickLogo}
                            />
                        </div>
                        {(this.props.canChangeColorMode || this.props.canChangeLanguage || this.props.canChangeTheme) &&
                        (<SettingsMenu
                            canChangeLanguage={this.props.canChangeLanguage}
                            canChangeColorMode={this.props.canChangeColorMode}
                            canChangeTheme={this.props.canChangeTheme}
                            hasActiveMembership={this.props.hasActiveMembership}
                            isRtl={this.props.isRtl}
                            onRequestClose={this.props.onRequestCloseSettings}
                            onRequestOpen={this.props.onClickSettings}
                            settingsMenuOpen={this.props.settingsMenuOpen}
                        />)}
                        {(this.props.canManageFiles) && (
                            <div
                                className={classNames(styles.menuBarItem, styles.hoverable, {
                                    [styles.active]: this.props.fileMenuOpen
                                })}
                                onClick={this.props.onClickFile}
                            >
                                <img src={fileIcon} />
                                <span className={styles.collapsibleLabel}>
                                    <FormattedMessage
                                        defaultMessage="File"
                                        description="Text for file dropdown menu"
                                        id="gui.menuBar.file"
                                    />
                                </span>
                                <img src={dropdownCaret} />
                                <MenuBarMenu
                                    className={classNames(styles.menuBarMenu)}
                                    open={this.props.fileMenuOpen}
                                    place={this.props.isRtl ? 'left' : 'right'}
                                    onRequestClose={this.props.onRequestCloseFile}
                                >
                                    <MenuSection>
                                        <MenuItem
                                            isRtl={this.props.isRtl}
                                            onClick={this.handleClickNew}
                                        >
                                            {newProjectMessage}
                                        </MenuItem>
                                    </MenuSection>
                                    {(this.props.canSave || this.props.canCreateNew ||
                                        this.props.canCreateCopy || this.props.canRemix) && (
                                        <MenuSection>
                                            {(this.props.canSave || this.props.canCreateNew) && (
                                                <MenuItem onClick={this.handleClickSave}>
                                                    {saveNowMessage}
                                                </MenuItem>
                                            )}
                                            {this.props.canCreateCopy && (
                                                <MenuItem onClick={this.handleClickSaveAsCopy}>
                                                    {createCopyMessage}
                                                </MenuItem>
                                            )}
                                            {this.props.canRemix && (
                                                <MenuItem onClick={this.handleClickRemix}>
                                                    {remixMessage}
                                                </MenuItem>
                                            )}
                                        </MenuSection>
                                    )}
                                    <MenuSection>
                                        <MenuItem
                                            onClick={this.props.onStartSelectingFileUpload}
                                        >
                                            {this.props.intl.formatMessage(sharedMessages.loadFromComputerTitle)}
                                        </MenuItem>
                                        <SB3Downloader>{(className, downloadProjectCallback) => (
                                            <MenuItem
                                                className={className}
                                                onClick={this.getSaveToComputerHandler(downloadProjectCallback)}
                                            >
                                                <FormattedMessage
                                                    defaultMessage="Save to your computer"
                                                    description="Menu bar item for downloading a project to your computer" // eslint-disable-line max-len
                                                    id="gui.menuBar.downloadToComputer"
                                                />
                                            </MenuItem>
                                        )}</SB3Downloader>
                                    </MenuSection>
                                </MenuBarMenu>
                            </div>
                        )}

                        {(this.props.canManageFiles && this.isExperienceDays) && (
                            <div
                                className={classNames(styles.menuBarItem, styles.hoverable, {
                                    [styles.active]: this.state.templateMenuOpen
                                })}
                                onClick={this.handleClickTemplate}
                            >
                                <img src={helpIcon} />
                                <span className={styles.collapsibleLabel}>
                                    <FormattedMessage
                                        defaultMessage="Template"
                                        description="Text for template dropdown menu"
                                        id="gui.menuBar.template"
                                    />
                                </span>
                                <img src={dropdownCaret} />

                                <MenuBarMenu
                                    className={classNames(styles.menuBarMenu)}
                                    open={this.state.templateMenuOpen}
                                    place={this.props.isRtl ? 'left' : 'right'}
                                    onRequestClose={this.handleRequestCloseTemplate}
                                >
                                    <MenuSection>
                                        {this.state.templateDataLoading ? (
                                            <MenuItem
                                                isRtl={this.props.isRtl}
                                                className={styles.hoverable}
                                            >
                                                Loading...
                                            </MenuItem>
                                        ) : this.state.templateDataError ? (
                                            <MenuItem
                                                isRtl={this.props.isRtl}
                                                className={styles.hoverable}
                                            >
                                                Failed load template
                                            </MenuItem>
                                        ) : (this.state.templateData || []).length === 0 ? (
                                            <MenuItem
                                                isRtl={this.props.isRtl}
                                                className={styles.hoverable}
                                            >
                                                No templates
                                            </MenuItem>
                                        ) : (
                                            (this.state.templateData || []).map(group => (
                                                <MenuItem
                                                    key={group.group}
                                                    isRtl={this.props.isRtl}
                                                    className={styles.hoverable}
                                                >
                                                    {group.group}

                                                    <Submenu place={this.props.isRtl ? 'left' : 'right'}>
                                                        {(group.items || []).map(item => (
                                                            <TemplateLoadMenuItem
                                                                key={`${group.group}-${item.label}`}
                                                                groupName={group.group}
                                                                isRtl={this.props.isRtl}
                                                                item={item}
                                                                onSelect={this.handleLoadTemplateFromApi}
                                                            />
                                                        ))}
                                                    </Submenu>
                                                </MenuItem>
                                            ))
                                        )}
                                    </MenuSection>
                                </MenuBarMenu>
                            </div>
                        )}

                        {this.state.templateCardsOpen ? (
                            <Cards
                                activeDeckId={this.state.templateCardsDeckId}
                                content={this.state.templateCardsContent}
                                dragging={this.state.templateCardsDragging}
                                expanded={this.state.templateCardsExpanded}
                                isRtl={this.props.isRtl}
                                locale={this.props.locale || 'en'}
                                step={this.state.templateCardsStep}
                                x={this.state.templateCardsX}
                                y={this.state.templateCardsY}

                                // required callbacks:
                                onCloseCards={this.handleCloseTemplateCards}
                                onShrinkExpandCards={this.handleToggleTemplateCardsExpand}
                                onDrag={this.handleTemplateCardsDrag}
                                onStartDrag={this.handleTemplateCardsStartDrag}
                                onEndDrag={this.handleTemplateCardsEndDrag}

                                // ini wajib tapi bisa noop karena kita tidak pakai next/prev:
                                onNextStep={this.handleTemplateCardsNextStep}
                                onPrevStep={this.handleTemplateCardsPrevStep}
                                onActivateDeckFactory={this.handleActivateTemplateDeckFactory}
                                onShowAll={this.handleCloseTemplateCards}

                                // kalau kamu nggak mau video wistia:
                                showVideos={false}
                            />
                        ) : null}

                        
                        {this.props.isTotallyNormal && (
                            <div
                                className={classNames(styles.menuBarItem, styles.hoverable, {
                                    [styles.active]: this.props.modeMenuOpen
                                })}
                                onClick={this.props.onClickMode}
                            >
                                <div className={classNames(styles.editMenu)}>
                                    <FormattedMessage
                                        defaultMessage="Mode"
                                        description="Mode menu item in the menu bar"
                                        id="gui.menuBar.modeMenu"
                                    />
                                </div>
                                <MenuBarMenu
                                    className={classNames(styles.menuBarMenu)}
                                    open={this.props.modeMenuOpen}
                                    place={this.props.isRtl ? 'left' : 'right'}
                                    onRequestClose={this.props.onRequestCloseMode}
                                >
                                    <MenuSection>
                                        <MenuItem onClick={this.handleSetMode('NOW')}>
                                            <span className={classNames({[styles.inactive]: !this.props.modeNow})}>
                                                {'✓'}
                                            </span>
                                            {' '}
                                            <FormattedMessage
                                                defaultMessage="Normal mode"
                                                description="April fools: resets editor to not have any pranks"
                                                id="gui.menuBar.normalMode"
                                            />
                                        </MenuItem>
                                        <MenuItem onClick={this.handleSetMode('2020')}>
                                            <span className={classNames({[styles.inactive]: !this.props.mode2020})}>
                                                {'✓'}
                                            </span>
                                            {' '}
                                            <FormattedMessage
                                                defaultMessage="Caturday mode"
                                                description="April fools: Cat blocks mode"
                                                id="gui.menuBar.caturdayMode"
                                            />
                                        </MenuItem>
                                    </MenuSection>
                                </MenuBarMenu>
                            </div>
                        )}
                    </div>
                    {this.props.canEditTitle ? (
                        <div className={classNames(styles.menuBarItem, styles.growable, styles.projectTitleGroup)}>
                            <MenuBarItemTooltip
                                enable
                                id="title-field"
                            >
                                <ProjectTitleInput
                                    className={classNames(styles.titleFieldGrowable)}
                                />
                            </MenuBarItemTooltip>
                            {(this.props.canSave || this.props.canCreateNew) ? (
                                <SaveStatus
                                    canCreateNew={this.props.canCreateNew}
                                    canSave={this.props.canSave}
                                    className={styles.titleSaveButton}
                                />
                            ) : null}
                        </div>
                    ) : ((this.props.authorUsername && this.props.authorUsername !== this.props.username) ? (
                        <AuthorInfo
                            className={styles.authorInfo}
                            imageUrl={this.props.authorThumbnailUrl}
                            projectTitle={this.props.projectTitle}
                            userId={this.props.authorId}
                            username={this.props.authorUsername}
                            avatarBadge={this.props.authorAvatarBadge}
                        />
                    ) : null)}
                    
                </div>

                {menuOpts && menuOpts.canHaveSession ? (
                    <div className={styles.accountInfoGroup}>
                        {this.props.username ? (
                            <AccountNav
                                avatarBadge={this.props.avatarBadge}
                                avatarUrl={menuOpts.avatarUrl}
                                className={styles.accountNavMenu}
                                accountSettingsUrl={menuOpts.accountSettingsUrl}
                                isOpen={this.props.accountMenuOpen}
                                isRtl={this.props.isRtl}
                                menuBarMenuClassName={styles.menuBarMenu}
                                myClassUrl={menuOpts.myClassUrl}
                                myClassesUrl={menuOpts.myClassesUrl}
                                myStuffUrl={menuOpts.myStuffUrl}
                                profileUrl={menuOpts.profileUrl}
                                username={this.props.username}
                                onClick={this.props.onClickAccount}
                                onClose={this.props.onRequestCloseAccount}
                                onLogOut={menuOpts.canLogout ? this.props.onLogOut : null}
                                onOpenMyStuff={this.props.onOpenMyStuff}
                                onOpenPassword={this.props.onOpenPassword}
                                onOpenProfile={this.props.onOpenProfile}
                            />
                        ) : (
                            <React.Fragment>
                                {menuOpts.canLogin && this.props.renderLogin ? (
                                    <div
                                        className={classNames(styles.menuBarItem, styles.hoverable, {
                                            [styles.active]: this.props.loginMenuOpen
                                        })}
                                        onClick={this.props.onClickLogin}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Masuk"
                                            description="Button text for IKOOS user login"
                                            id="gui.menuBar.ikoosLogin"
                                        />
                                        <LoginDropdown
                                            className={styles.menuBarMenu}
                                            isOpen={this.props.loginMenuOpen}
                                            isRtl={this.props.isRtl}
                                            renderLogin={this.props.renderLogin}
                                            onClose={this.props.onRequestCloseLogin}
                                        />
                                    </div>
                                ) : null}
                                {menuOpts.canRegister && this.props.onOpenRegistration ? (
                                    <div
                                        className={classNames(styles.menuBarItem, styles.hoverable)}
                                        onClick={this.props.onOpenRegistration}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Daftar"
                                            description="Button text for IKOOS user registration"
                                            id="gui.menuBar.ikoosRegister"
                                        />
                                    </div>
                                ) : null}
                            </React.Fragment>
                        )}
                    </div>
                ) : null}

                {aboutButton}
            </Box>
        );
    }
}

MenuBar.propTypes = {
    aboutMenuOpen: PropTypes.bool,
    accountMenuOpen: PropTypes.bool,
    ariaLabel: PropTypes.string,
    ariaRole: PropTypes.string,
    authorId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    authorThumbnailUrl: PropTypes.string,
    authorUsername: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    authorAvatarBadge: PropTypes.number,
    autoUpdateProject: PropTypes.func,
    canChangeLanguage: PropTypes.bool,
    canChangeColorMode: PropTypes.bool,
    canChangeTheme: PropTypes.bool,
    canCreateCopy: PropTypes.bool,
    canCreateNew: PropTypes.bool,
    canEditTitle: PropTypes.bool,
    canManageFiles: PropTypes.bool,
    canRemix: PropTypes.bool,
    canSave: PropTypes.bool,
    canShare: PropTypes.bool,
    className: PropTypes.string,
    confirmReadyToReplaceProject: PropTypes.func,
    currentLocale: PropTypes.string.isRequired,
    editMenuOpen: PropTypes.bool,
    enableCommunity: PropTypes.bool,
    fileMenuOpen: PropTypes.bool,
    hasActiveMembership: PropTypes.bool,
    intl: intlShape,
    isRtl: PropTypes.bool,
    isShared: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isTotallyNormal: PropTypes.bool,
    isUpdating: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    loginMenuOpen: PropTypes.bool,
    logo: PropTypes.string,
    mode1920: PropTypes.bool,
    mode1990: PropTypes.bool,
    mode2020: PropTypes.bool,
    mode220022BC: PropTypes.bool,
    modeMenuOpen: PropTypes.bool,
    modeNow: PropTypes.bool,
    onClickAbout: PropTypes.oneOfType([
        PropTypes.func, // button mode: call this callback when the About button is clicked
        PropTypes.arrayOf( // menu mode: list of items in the About menu
            PropTypes.shape({
                title: PropTypes.string, // text for the menu item
                onClick: PropTypes.func // call this callback when the menu item is clicked
            })
        )
    ]),
    onClickAccount: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickFile: PropTypes.func,
    onClickLogin: PropTypes.func,
    onClickLogo: PropTypes.func,
    onClickMode: PropTypes.func,
    onClickCreateProject: PropTypes.func,
    onClickNew: PropTypes.func,
    onClickRemix: PropTypes.func,
    onClickSave: PropTypes.func,
    onClickSaveAsCopy: PropTypes.func,
    onClickSettings: PropTypes.func,
    onLogOut: PropTypes.func,
    onOpenMyStuff: PropTypes.func,
    onOpenPassword: PropTypes.func,
    onOpenProfile: PropTypes.func,
    onOpenRegistration: PropTypes.func,
    onOpenTipLibrary: PropTypes.func,
    onOpenDebugModal: PropTypes.func,
    onProjectTelemetryEvent: PropTypes.func,
    onRequestCloseAbout: PropTypes.func,
    onRequestCloseAccount: PropTypes.func,
    onRequestCloseEdit: PropTypes.func,
    onRequestCloseFile: PropTypes.func,
    onRequestCloseLogin: PropTypes.func,
    onRequestCloseMode: PropTypes.func,
    onRequestCloseSettings: PropTypes.func,
    onRequestOpenAbout: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onSetTimeTravelMode: PropTypes.func,
    onShare: PropTypes.func,
    onStartSelectingFileUpload: PropTypes.func,
    onToggleLoginOpen: PropTypes.func,
    platform: PropTypes.oneOf(Object.keys(PLATFORM)),
    projectTitle: PropTypes.string,
    renderLogin: PropTypes.func,
    settingsMenuOpen: PropTypes.bool,
    shouldSaveBeforeTransition: PropTypes.func,
    showComingSoon: PropTypes.bool,
    username: PropTypes.string,
    avatarBadge: PropTypes.number,
    userOwnsProject: PropTypes.bool,

    accountMenuOptions: AccountMenuOptionsPropTypes,

    vm: PropTypes.instanceOf(VM).isRequired
};

MenuBar.defaultProps = {
    logo: ikoosLogo,
    onShare: () => {}
};

const mapStateToProps = (state, ownProps) => {
    const loadingState = state.scratchGui.projectState.loadingState;
    const user = state.session && state.session.session && state.session.session.user;
    const permissions = state.session && state.session.permissions;
    const sessionExists = state.session && typeof state.session.session !== 'undefined';

    return {
        aboutMenuOpen: aboutMenuOpen(state),
        accountMenuOpen: accountMenuOpen(state),
        currentLocale: state.locales.locale,
        fileMenuOpen: fileMenuOpen(state),
        editMenuOpen: editMenuOpen(state),
        isRtl: state.locales.isRtl,
        isUpdating: getIsUpdating(loadingState),
        isShowingProject: getIsShowingProject(loadingState),
        locale: state.locales.locale,
        loginMenuOpen: loginMenuOpen(state),
        modeMenuOpen: modeMenuOpen(state),
        projectTitle: state.scratchGui.projectTitle,
        settingsMenuOpen: settingsMenuOpen(state),
        username: ownProps.username ?? (user ? user.username : null),
        avatarBadge: user ? user.membership_avatar_badge : null,
        userIsEducator: permissions && permissions.educator,
        vm: state.scratchGui.vm,
        mode220022BC: isTimeTravel220022BC(state),
        mode1920: isTimeTravel1920(state),
        mode1990: isTimeTravel1990(state),
        mode2020: isTimeTravel2020(state),
        modeNow: isTimeTravelNow(state),

        platform: state.scratchGui.platform.platform,

        userOwnsProject: ownProps.userOwnsProject ?? (
            ownProps.authorUsername && user && (ownProps.authorUsername === user.username)
        ),

        accountMenuOptions: ownProps.accountMenuOptions ?? {
            canHaveSession: sessionExists ?? false,

            canRegister: true,
            canLogin: true,
            canLogout: true,

            avatarUrl: user?.thumbnailUrl,
            myStuffUrl: '/mystuff/',
            profileUrl: user && `/users/${user.username}`,
            myClassesUrl: permissions?.educator ? '/educators/classes/' : null,
            myClassUrl: user && permissions?.student ? `/classes/${user.classroomId}/` : null,
            accountSettingsUrl: '/accounts/settings/'
        }
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    autoUpdateProject: () => dispatch(autoUpdateProject()),
    onOpenTipLibrary: () => dispatch(openTipsLibrary()),
    onOpenDebugModal: () => dispatch(openDebugModal()),
    onClickAccount: () => dispatch(openAccountMenu()),
    onRequestCloseAccount: () => dispatch(closeAccountMenu()),
    onClickFile: () => dispatch(openFileMenu()),
    onRequestCloseFile: () => dispatch(closeFileMenu()),
    onClickEdit: () => dispatch(openEditMenu()),
    onRequestCloseEdit: () => dispatch(closeEditMenu()),
    onClickLogin: ownProps.onClickLogin ?? (() => dispatch(openLoginMenu())),
    onRequestCloseLogin: () => dispatch(closeLoginMenu()),
    onClickMode: () => dispatch(openModeMenu()),
    onRequestCloseMode: () => dispatch(closeModeMenu()),
    onRequestOpenAbout: () => dispatch(openAboutMenu()),
    onRequestCloseAbout: () => dispatch(closeAboutMenu()),
    onClickSettings: () => dispatch(openSettingsMenu()),
    onRequestCloseSettings: () => dispatch(closeSettingsMenu()),
    onClickNew: needSave => dispatch(requestNewProject(needSave)),
    onClickCreateProject: () => dispatch(createProject()),
    onClickRemix: () => dispatch(remixProject()),
    onClickSave: () => dispatch(manualUpdateProject()),
    onClickSaveAsCopy: () => dispatch(saveProjectAsCopy()),
    onSeeCommunity: ownProps.onSeeCommunity ?? (() => dispatch(setPlayer(true))),
    onSetTimeTravelMode: mode => dispatch(setTimeTravel(mode))
});

export default compose(
    injectIntl,
    MenuBarHOC,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(MenuBar);
